import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MobileBottomBar from './components/MobileBottomBar';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import About from './pages/About';
import SeaFreight from './pages/SeaFreight';
import AirFreight from './pages/AirFreight';
import LandFreight from './pages/LandFreight';
import ProjectLogistics from './pages/ProjectLogistics';
import CustomsClearance from './pages/CustomsClearance';
import Warehousing from './pages/Warehousing';
import Industries from './pages/Industries';
import GlobalNetwork from './pages/GlobalNetwork';
import Contact from './pages/Contact';
import Quote from './pages/Quote';
import NotFound from './pages/NotFound';
import './styles/global.css';

function App() {
  return (
    <Router>
      <ScrollToTop />
      <a href="#main-content" className="skip-to-content">Skip to content</a>
      <Header />
      <main id="main-content">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/services/sea-freight" element={<SeaFreight />} />
          <Route path="/services/air-freight" element={<AirFreight />} />
          <Route path="/services/land-freight" element={<LandFreight />} />
          <Route path="/services/project-logistics" element={<ProjectLogistics />} />
          <Route path="/services/customs-clearance" element={<CustomsClearance />} />
          <Route path="/services/warehousing" element={<Warehousing />} />
          <Route path="/industries" element={<Industries />} />
          <Route path="/global-network" element={<GlobalNetwork />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/quote" element={<Quote />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <MobileBottomBar />
    </Router>
  );
}

export default App;
